// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../styles/styles.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routes-module_nav_button_PeRO9 {
  font-size: large !important;
  padding: 24px !important;
}

.routes-module_error_state_GVOrF > * {
  max-width: 600px !important;
  font-size: large;
}

.routes-module_error_state_GVOrF * {
  color: var(--site-error-color) !important;
}

.routes-module_content_background_yNmfq {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/client/routes/routes.module.css"],"names":[],"mappings":"AAAA;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EAEE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".nav_button {\n  composes: primary_button_bold from 'Styles/styles.module.css';\n  font-size: large !important;\n  padding: 24px !important;\n}\n\n.error_state > * {\n  max-width: 600px !important;\n  font-size: large;\n}\n\n.error_state * {\n  color: var(--site-error-color) !important;\n}\n\n.content_background {\n  composes: primary_background from 'Styles/colors.module.css';\n  flex: 1 1 auto;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav_button": `routes-module_nav_button_PeRO9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_bold"]}`,
	"error_state": `routes-module_error_state_GVOrF`,
	"content_background": `routes-module_content_background_yNmfq ${___CSS_LOADER_ICSS_IMPORT_1___.locals["primary_background"]}`
};
export default ___CSS_LOADER_EXPORT___;
